import { modalController, popoverController } from '@ionic/core';
import { VueDelegate } from './framework-delegate';
const oldModalCreate = modalController.create.bind(modalController);
modalController.create = (options) => {
    return oldModalCreate(Object.assign(Object.assign({}, options), { delegate: VueDelegate() }));
};
const oldPopoverCreate = popoverController.create.bind(popoverController);
popoverController.create = (options) => {
    return oldPopoverCreate(Object.assign(Object.assign({}, options), { delegate: VueDelegate() }));
};
export { modalController, popoverController };
//# sourceMappingURL=controllers.js.map